import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type LegalPage = 'privacy' | 'legal' | 'cookies' | null;
interface LegalModalProps {
  activePage: LegalPage;
  onClose: () => void;
}
function PrivacyContent() {
  return <>
      <h2 className="text-3xl font-serif text-stone-900 mb-8" data-id="element-142">
        Política de Privacidad
      </h2>

      <p className="text-stone-600 mb-6" data-id="element-143">
        En esta web se respetan y cuidan los datos personales de los usuarios.
      </p>

      <div className="space-y-6 text-stone-700" data-id="element-144">
        <div data-id="element-145">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-146">Responsable</h3>
          <p data-id="element-147">VANII</p>
          <p data-id="element-148">
            Correo:{' '}
            <a href="mailto:yogavanesa@gmail.com" className="text-violet-600 hover:underline" data-id="element-149">
              yogavanesa@gmail.com
            </a>
          </p>
        </div>

        <div data-id="element-150">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-151">
            ¿Qué datos recogemos?
          </h3>
          <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-152">
            <li data-id="element-153">Nombre</li>
            <li data-id="element-154">Email</li>
            <li data-id="element-155">Teléfono (si aplica)</li>
          </ul>
        </div>

        <div data-id="element-156">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-157">
            ¿Para qué usamos tus datos?
          </h3>
          <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-158">
            <li data-id="element-159">Responder a consultas</li>
            <li data-id="element-160">Gestionar reservas</li>
            <li data-id="element-161">Enviar información relacionada con los servicios</li>
          </ul>
        </div>

        <div data-id="element-162">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-163">Legitimación</h3>
          <p data-id="element-164">Consentimiento del usuario al contactar o reservar.</p>
        </div>

        <div data-id="element-165">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-166">Conservación</h3>
          <p data-id="element-167">
            Los datos se conservarán mientras exista relación o hasta que el
            usuario solicite su eliminación.
          </p>
        </div>

        <div data-id="element-168">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-169">Derechos</h3>
          <p data-id="element-170">
            Puedes acceder, rectificar o eliminar tus datos escribiendo a:{' '}
            <a href="mailto:yogavanesa@gmail.com" className="text-violet-600 hover:underline" data-id="element-171">
              yogavanesa@gmail.com
            </a>
          </p>
        </div>
      </div>
    </>;
}
function LegalNoticeContent() {
  return <>
      <h2 className="text-3xl font-serif text-stone-900 mb-8" data-id="element-172">Aviso Legal</h2>

      <div className="space-y-6 text-stone-700" data-id="element-173">
        <div data-id="element-174">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-175">Titular</h3>
          <p data-id="element-176">VANII</p>
          <p data-id="element-177">
            Email:{' '}
            <a href="mailto:yogavanesa@gmail.com" className="text-violet-600 hover:underline" data-id="element-178">
              yogavanesa@gmail.com
            </a>
          </p>
        </div>

        <div data-id="element-179">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-180">
            Condiciones de uso
          </h3>
          <p data-id="element-181">
            El acceso a esta web implica la aceptación de las condiciones aquí
            establecidas.
          </p>
          <p className="mt-2" data-id="element-182">
            No nos hacemos responsables del uso indebido de la información
            contenida en esta web.
          </p>
        </div>

        <div data-id="element-183">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-184">
            Propiedad intelectual
          </h3>
          <p data-id="element-185">
            Todos los contenidos de esta web (textos, imágenes, logotipos,
            diseño) son propiedad de VANII y están protegidos por las leyes de
            propiedad intelectual. Queda prohibida su reproducción sin
            autorización expresa.
          </p>
        </div>

        <div data-id="element-186">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-187">
            Legislación aplicable
          </h3>
          <p data-id="element-188">
            Este aviso legal se rige por la legislación española vigente. Para
            cualquier controversia, las partes se someterán a los juzgados y
            tribunales correspondientes.
          </p>
        </div>
      </div>
    </>;
}
function CookiesContent() {
  return <>
      <h2 className="text-3xl font-serif text-stone-900 mb-8" data-id="element-189">
        Política de Cookies
      </h2>

      <div className="space-y-6 text-stone-700" data-id="element-190">
        <div data-id="element-191">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-192">
            ¿Qué son las cookies?
          </h3>
          <p data-id="element-193">
            Las cookies son pequeños archivos de texto que se almacenan en tu
            dispositivo cuando visitas una página web. Sirven para mejorar tu
            experiencia de navegación.
          </p>
        </div>

        <div data-id="element-194">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-195">
            ¿Qué cookies utilizamos?
          </h3>
          <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-196">
            <li data-id="element-197">
              <strong data-id="element-198">Cookies técnicas:</strong> Necesarias para el
              funcionamiento básico de la web.
            </li>
            <li data-id="element-199">
              <strong data-id="element-200">Cookies analíticas:</strong> Nos ayudan a entender cómo
              los usuarios interactúan con la web.
            </li>
          </ul>
        </div>

        <div data-id="element-201">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-202">
            ¿Cómo gestionar las cookies?
          </h3>
          <p data-id="element-203">
            Puedes aceptar, rechazar o configurar las cookies desde tu
            navegador. Ten en cuenta que desactivar algunas cookies puede
            afectar a la funcionalidad de la web.
          </p>
        </div>

        <div data-id="element-204">
          <h3 className="font-semibold text-stone-900 mb-2" data-id="element-205">Más información</h3>
          <p data-id="element-206">
            Si tienes dudas sobre nuestra política de cookies, puedes
            contactarnos en:{' '}
            <a href="mailto:yogavanesa@gmail.com" className="text-violet-600 hover:underline" data-id="element-207">
              yogavanesa@gmail.com
            </a>
          </p>
        </div>
      </div>
    </>;
}
export function LegalModal({
  activePage,
  onClose
}: LegalModalProps) {
  useEffect(() => {
    if (activePage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [activePage]);
  return <AnimatePresence data-id="element-208">
      {activePage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-209">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-210" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} transition={{
        duration: 0.3
      }} onClick={e => e.stopPropagation()} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" data-id="element-211">
            {/* Close button */}
            <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 rounded-full bg-stone-100 text-stone-600 hover:bg-stone-200 hover:text-stone-900 transition-colors" aria-label="Cerrar" data-id="element-212">
              <X size={20} data-id="element-213" />
            </button>

            {/* Content */}
            <div className="p-8 md:p-10 overflow-y-auto max-h-[85vh] text-base leading-relaxed" data-id="element-214">
              {activePage === 'privacy' && <PrivacyContent data-id="element-215" />}
              {activePage === 'legal' && <LegalNoticeContent data-id="element-216" />}
              {activePage === 'cookies' && <CookiesContent data-id="element-217" />}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export type { LegalPage };